(() => {
'use strict';
if(window.TTTreliCart)return;
// Shared cart adapter; prices and physical inventory are validated by the checkout service.
const tiers = ['1', '2', '3'];
const attribute = tier => `tt_treli_pack_${tier}`;


// A checkout session is not a purchase. Paid-order tracking belongs to the payment confirmation.
const trackedSessions = new Set();
const trackingCatalog = {
 '1': {id:'49034169549052', price:93500},
 '2': {id:'51251122438396', price:144500},
 '3': {id:'51251186106620', price:187000}
};
function trackCommerce(event, lines, months, sessionId) {
 try {
  const key = sessionId ? 'tt_tracked_checkout_' + sessionId : null;
  if(key) {
   if(trackedSessions.has(key)) return;
   try {if(sessionStorage.getItem(key))return;}catch(_){}
  }
  const items=lines.map(line=>({
   item_id:trackingCatalog[line.tier].id,
   item_name:'Three Tails Nutre G · '+(Number(line.tier)*30)+' scoops',
   item_variant:line.mode==='recurring'?'Suscripción':'Compra única',
   price:line.unit_price,quantity:line.quantity,
   purchase_mode:line.mode,frequency_months:line.mode==='recurring'?months:0
  }));
  const value=items.reduce((sum,item)=>sum+item.price*item.quantity,0);
  if(!items.length || !Number.isFinite(value) || value<=0)return;
  const privacy=window.Shopify?.customerPrivacy;
  let sent=false;
  if(typeof window.gtag==='function' && (!privacy?.analyticsProcessingAllowed || privacy.analyticsProcessingAllowed())) {
   try {window.gtag('event',event,{currency:'COP',value,items,payment_provider:'treli',frequency_months:months,transport_type:'beacon'});sent=true;}catch(_){}
  }
  if(typeof window.fbq==='function' && (!privacy?.marketingAllowed || privacy.marketingAllowed())) {
   try {window.fbq('track',event==='add_to_cart'?'AddToCart':'InitiateCheckout',{
    currency:'COP',value,content_type:'product',content_ids:items.map(i=>i.item_id),
    contents:items.map(i=>({id:i.item_id,quantity:i.quantity,item_price:i.price})),
    num_items:items.reduce((sum,i)=>sum+i.quantity,0)
   },sessionId?{eventID:'tt_checkout_'+sessionId}:undefined);sent=true;}catch(_){}
  }
  if(key && sent){trackedSessions.add(key);try{sessionStorage.setItem(key,'1');}catch(_){}}
 } catch(_) { /* Measurement must never prevent adding products or paying. */ }
}

function readQuantity(value) {
  if (value == null || value === '') return 0;
  if (!/^[1-9]\d*$/.test(String(value))) throw new Error('Cantidad de suscripción inválida.');
  const quantity = Number(value);
  if (!Number.isSafeInteger(quantity) || quantity > 100000) throw new Error('Cantidad fuera de rango.');
  return quantity;
}

function subscriptionLines(cart) {
  return tiers.flatMap(tier => {
    const quantity = readQuantity(cart.attributes?.[attribute(tier)]);
    return quantity ? [{tier, mode: 'recurring', quantity}] : [];
  });
}

function checkoutLines(cart, variantToTier) {
  const recurring = subscriptionLines(cart);
  if (!recurring.length) return {checkout: 'shopify'};
  if (cart.currency !== 'COP') throw new Error('El pago de suscripción requiere COP.');
  // Treli owns the prices. Accept Shopify's automatic offer only when totals match it.
  const oncePrices = {'1':11000000, '2':17000000, '3':22000000};
  const once = cart.items.map(item => {
    const tier = variantToTier[String(item.variant_id)];
    if (!tiers.includes(tier) || item.selling_plan_allocation || item.item_components?.length || item.parent_relationship) {
      throw new Error('Hay un producto que todavía no está habilitado para el pago mixto.');
    }
    if (item.final_line_price !== oncePrices[tier] * item.quantity) {
      throw new Error('Para conservar el cupón de tu compra única, págala por separado de la suscripción. Tu carrito se conserva.');
    }
    const quantity = readQuantity(item.quantity);
    if (!quantity) throw new Error('Cantidad de producto inválida.');
    return {tier, mode: 'one_time', quantity};
  });
  if (once.length && cart.total_price !== cart.items.reduce((sum,item)=>sum+item.final_line_price,0)) {
    throw new Error('Para conservar el descuento de tu compra única, págala por separado de la suscripción. Tu carrito se conserva.');
  }
  return {checkout: 'treli', lines: [...once, ...recurring], months: Number(cart.attributes?.tt_treli_months || 1)};
}

function createSubscriptionCart({fetchCart, updateAttributes}) {
  let queue = Promise.resolve();
  function mutate(tier, operation, months, options) {
    if (!tiers.includes(String(tier))) return Promise.reject(new Error('Presentación inválida.'));
    const job = queue.then(async () => {
      const cart = await fetchCart();
      if(months !== undefined && ![1,2,3].includes(months)) throw new Error('Frecuencia inválida.');
      if(months !== undefined && subscriptionLines(cart).length && Number(cart.attributes?.tt_treli_months || 1) !== months) throw new Error('Tu carrito tiene otra frecuencia. Cámbiala en el carrito para todas tus suscripciones antes de añadir esta selección.');
      const current = readQuantity(cart.attributes?.[attribute(tier)]);
      const quantity = operation(current);
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 100000) {
        throw new Error('Cantidad inválida.');
      }
      // Update only this attribute; do not overwrite unrelated cart attributes or line items.
      return updateAttributes({[attribute(tier)]: quantity ? String(quantity) : '', ...(months === undefined ? {} : {tt_treli_months:String(months)})}, options);
    });
    queue = job.catch(() => {});
    return job;
  }
  return {
    add(tier, quantity = 1, months, options) {
      if (!Number.isSafeInteger(quantity) || quantity <= 0) return Promise.reject(new Error('Cantidad inválida.'));
      return mutate(tier, current => current + quantity, months, options).then(result=>{
        trackCommerce('add_to_cart',[{tier:String(tier),mode:'recurring',quantity,unit_price:trackingCatalog[tier].price}],Number(result.attributes?.tt_treli_months || months || 1));
        return result;
      });
    },
    set(tier, quantity) {return mutate(tier, () => quantity);},
    remove(tier) {return mutate(tier, () => 0);},
    frequency(months) {
      if(![1,2,3].includes(months)) return Promise.reject(new Error("Frecuencia inválida."));
      const job=queue.then(()=>updateAttributes({tt_treli_months:String(months)}));queue=job.catch(()=>{});return job;
    },
    settled() {return queue;}
  };
}
const root = () => (window.Shopify?.routes?.root || '/').replace(/\/+$/, '') + '/';
async function boundedFetch(url,options={},milliseconds=45000){
 const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),milliseconds);
 try{return await fetch(url,{...options,signal:controller.signal});}
 catch(error){if(controller.signal.aborted)throw new Error('La conexión tardó demasiado. Intenta de nuevo; tu carrito se conserva.');throw error;}
 finally{clearTimeout(timer);}
}
async function fetchCart(){const r=await boundedFetch(root()+'cart.js',{},15000);if(!r.ok)throw new Error('No pudimos leer tu carrito.');return r.json();}
const adapter=createSubscriptionCart({fetchCart,updateAttributes:async (attributes, options = {})=>{
  const r=await fetch(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes,sections:['cart-drawer'],sections_url:location.pathname})});
  const state=await r.json();if(!r.ok)throw new Error(state.description||'No pudimos actualizar tu carrito.');
  if(options.openDrawer === false){try{document.querySelector('cart-drawer')?.renderFromState?.(state);}catch(_){}return state;}
  if(!state.sections?.['cart-drawer']){const sections=await fetch(root()+'?sections=cart-drawer');if(!sections.ok)throw new Error('Recarga para ver tu selección.');state.sections=await sections.json();}
  const drawer=document.querySelector('cart-drawer');if(drawer && state.sections?.['cart-drawer'])drawer.renderFromState(state);
  if(location.pathname.replace(/\/$/,'')===root()+'cart')location.reload();
  return state;
}});
let checkoutJob = null;
let memoryAttempt = null;
// Both the purchase button and the drawer use the same mixed-cart checkout.
function checkout(config) {
 if(checkoutJob)return checkoutJob;
 checkoutJob=(async()=>{
  await adapter.settled();
  const cart=await fetchCart();
  const payload=checkoutLines(cart,config?.variants || {});
  if(payload.checkout==='shopify'){
   if(!cart.items.length)throw new Error('Tu carrito está vacío. Elige una presentación para continuar.');
   location.assign(root()+'checkout');return;
  }
  if(config?.endpoint!=='https://hq.3tails.co/treli/checkout')throw new Error('No pudimos abrir el pago. Tu selección se conserva.');
  if(![1,2,3].includes(payload.months))throw new Error('Frecuencia inválida. Revisa tu selección.');
  const fingerprint=JSON.stringify({token:cart.token,lines:payload.lines,months:payload.months});
  let attempt=memoryAttempt;
  try{attempt=JSON.parse(sessionStorage.getItem('tt_checkout_attempt')||'null') || attempt;}catch(_){}
  if(!attempt || attempt.fingerprint!==fingerprint){attempt={fingerprint,key:crypto.randomUUID()};}
  memoryAttempt=attempt;
  try{sessionStorage.setItem('tt_checkout_attempt',JSON.stringify(attempt));}catch(_){}
  const response=await boundedFetch(config.endpoint,{method:'POST',headers:{'Content-Type':'application/json','Idempotency-Key':attempt.key},body:JSON.stringify({lines:payload.lines,months:payload.months,cart_token:cart.token})});
  const result=await response.json();
  if(!response.ok)throw new Error(result.error||'No pudimos abrir el pago. Tu selección se conserva.');
  if(result.is_test!==false)throw new Error('No pudimos validar el entorno de pago.');
  const url=new URL(result.url);
  if(url.protocol!=='https:' || url.hostname!=='checkout.treli.co')throw new Error('No pudimos validar el enlace de pago.');
  trackCommerce('begin_checkout',result.quote?.lines,result.quote?.months || payload.months,result.session_id);
  location.assign(url.href);
 })().finally(()=>{checkoutJob=null;});
 return checkoutJob;
}
window.TTTreliCart={
 async add(tier,trigger,quantity=1,months=1,options={}){
  const result=await adapter.add(String(tier),quantity,months,options);
  if(options.openDrawer!==false)document.querySelector('cart-drawer')?.open(trigger);
  return result;
 },
 checkout
};
function showError(error){document.querySelectorAll('[data-tt-treli-error]').forEach(el=>{el.textContent=error.message||'No pudimos abrir el pago. Intenta de nuevo.';el.hidden=false;});}
document.addEventListener('change',async event=>{if(!event.target.matches('[data-tt-cart-frequency]'))return;event.target.disabled=true;try{await adapter.frequency(Number(event.target.value));}catch(error){showError(error);event.target.disabled=false;}});
let paying=false;
document.addEventListener('click',async event=>{
 const action=event.target.closest('[data-tt-treli-remove],[data-tt-treli-step],[data-tt-api-checkout]');
 if(!action)return;event.preventDefault();if(action.disabled||paying)return;action.disabled=true;
 const isCheckout=action.hasAttribute('data-tt-api-checkout'), originalHTML=action.innerHTML;
 if(isCheckout){action.textContent='Abriendo el pago…';action.setAttribute('aria-busy','true');document.querySelectorAll('[data-tt-treli-error]').forEach(el=>{el.hidden=true;el.textContent='';});}
 try{
  if(action.hasAttribute('data-tt-treli-remove')){await adapter.remove(action.dataset.ttTreliRemove);return;}
  if(action.hasAttribute('data-tt-treli-step')){
   const tier=action.dataset.tier;
   if(action.dataset.ttTreliStep==='1')await adapter.add(tier);
   else {await adapter.settled();const cart=await fetchCart();await adapter.set(tier,Math.max(0,readQuantity(cart.attributes?.[attribute(tier)])-1));}
   return;
  }
  if(paying)return;paying=true;
  const raw=document.querySelector('[data-tt-api-config]')?.textContent;
  const config=raw?JSON.parse(raw):null;
  await checkout(config);
 }catch(error){showError(error);}finally{action.disabled=false;paying=false;if(isCheckout){action.innerHTML=originalHTML;action.removeAttribute('aria-busy');}}
});

})();
